import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ElternService} from "../../../service/eltern.service";
import {FilterEngineService} from "../../../service/filter-engine.service";
import {getElternSearchCategories, IEltern} from "../../../models/IEltern.interface";

@Component({
  selector: 'app-select-eltern',
  templateUrl: './select-eltern.component.html',
  styleUrls: ['./select-eltern.component.scss']
})
export class SelectElternComponent implements OnInit {

  public eltern: IEltern[] = [];
  public query = "";
  public categories = getElternSearchCategories();

  constructor(
      public activeModal: NgbActiveModal,
      private elternService: ElternService,
      private filterService: FilterEngineService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.updateFilter();
  }

  async updateFilter(): Promise<void> {
    this.eltern = await this.filterService.filter(
        this.query,
        this.elternService.getList(),
        "selectElternDialog"
    );
  }

  select(eltern: IEltern): void {
    this.activeModal.close(eltern);
  }

}
